import { render } from "./ProjectSectionContent.vue?vue&type=template&id=3dcb623a"
import script from "./ProjectSectionContent.vue?vue&type=script&lang=js"
export * from "./ProjectSectionContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__